import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth';
import { UserRole } from '../models/auth_model';

/**
 * Guard para verificar roles específicos
 * Uso en rutas:
 * canActivate: [roleGuard([UserRole.ADMIN])]
 */
export const roleGuard = (allowedRoles: UserRole[]): CanActivateFn => {
  return (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      console.log('[roleGuard] Usuario no autenticado');
      router.navigate(['/login'], {
        queryParams: { returnUrl: state.url }
      });
      return false;
    }

    const currentRole = authService.userRole();
    console.log('[roleGuard] Rol actual:', currentRole, 'Tipo:', typeof currentRole);
    console.log('[roleGuard] Roles permitidos:', allowedRoles);
    console.log('[roleGuard] UserRole.ADMIN:', UserRole.ADMIN, 'Tipo:', typeof UserRole.ADMIN);

    if (authService.hasAnyRole(allowedRoles)) {
      console.log('[roleGuard] Acceso permitido');
      return true;
    }

    console.log('[roleGuard] Acceso denegado - redirigiendo a /unauthorized');
    router.navigate(['/unauthorized']);
    return false;
  };
};

/**
 * Guard específico para administradores
 */
export const adminGuard: CanActivateFn = roleGuard([UserRole.ADMIN]);